import _ from "lodash";
import React, { ChangeEvent, ReactElement, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Promo } from "./Promo";
import { PromoService } from "./PromoService";

interface IParams {
	onCreate: (promo: Promo) => void;
}

export const PromoForm = (props: IParams): ReactElement => {
	const [promo] = useState<Promo>(new Promo());
	const promoService = new PromoService();

	const handleSubmit = async () => {
		const newPromos = await promoService.create(promo);
		props.onCreate(newPromos);
	};

	return (
		<>
			<h4>Create Promo</h4>
			<Form>
				<Form.Group>
					<Form.Label>Name</Form.Label>
					<Form.Control
						type="text"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							promo.name = event.target.value;
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Description</Form.Label>
					<Form.Control
						type="text"
						as="textarea"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							promo.description = event.target.value;
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Amount</Form.Label>
					<Form.Control
						type="number"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							promo.amount = parseInt(event.target.value, 10);
						}}
					/>
				</Form.Group>
				<Button onClick={handleSubmit}>Create</Button>
			</Form>
		</>
	);
};
